module.exports = __webpack_public_path__ + "media/images/default/pages/about/main/33820-ad83045c1e06e9435f48f62d23f9b351.svg";